import { Link } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box component="footer" sx={{ backgroundColor: 'grey.100', mt: 'auto' }}>
      <Container maxWidth="xl" sx={{ py: 2, px: { xs: 2, sm: 3, lg: 4 } }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
          <Typography
            component={Link}
            to="/imprint"
            variant="body2"
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': {
                color: 'text.primary'
              }
            }}
          >
            Impressum
          </Typography>
          <Typography
            component={Link}
            to="/privacy"
            variant="body2"
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': {
                color: 'text.primary'
              }
            }}
          >
            Datenschutz
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
